import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { delay, share } from 'rxjs/operators';

@Injectable()
export class LayoutService {

  protected layoutSize$ = new Subject();

  changeLayoutSize() {
    this.layoutSize$.next(null);
  }

  onChangeLayoutSize(): Observable<any> {
    return this.layoutSize$.pipe(
      share(),
      delay(1),
    );
  }

  private _sheetDialogNb: number = 0;
  public get sheetDialogNb(): number {
    return this._sheetDialogNb;
  }

  public readonly widthByNb: { [key: number]: string } = {
    1: '90%',
    2: '85%',
    3: '82%',
    4: '79%',
    5: '76%',
  };
  public addSheetDialogNb() {
    this._sheetDialogNb++;
  }

  public removeSheetDialogNb() {
    if (this._sheetDialogNb > 0) {
      this._sheetDialogNb--;
    }
  }

  public resetSheetDialogNb() {
    this._sheetDialogNb = 0;
  }

}
